import { Checkbox } from '../Checkbox';
import { StyledQmarkCheckboxes } from './style';
import { useIntl } from 'react-intl';
import React, { useEffect, useState } from 'react';
import { ServicesFilterOptions } from 'types/FilterOptions';
import { Icon } from 'ui';

interface Props {
  services: ServicesFilterOptions[] | undefined;
}

export const AdditionalOptionsCheckboxes = ({ services }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isEmpty, setIsEmpty] = useState<boolean>(false);

  const intl = useIntl();

  const handleOnClick = () => {
    setIsOpen(!isOpen);
  };

  const visibleServices = services?.filter((service) => !service.hidden) || [];

  useEffect(() => {
    if (visibleServices.length === 0) {
      setIsOpen(false);
      setIsEmpty(true);
    } else {
      setIsEmpty(false);
    }
  }, [visibleServices]);

  return (
    <StyledQmarkCheckboxes>
      <div
        className={'qmark-filter-title'}
        onClick={!isEmpty ? handleOnClick : undefined}
      >
        <div>{intl.formatMessage({ id: 'form.options_filter_title' })}</div>
        <div className={`icon ${!isOpen ? 'collapsed' : ''}`}>
          <Icon name="arrow" />
        </div>
      </div>
      {isOpen && (
        <Checkbox name="services" options={visibleServices} filterView={true} />
      )}
    </StyledQmarkCheckboxes>
  );
};
